export enum OGCDLockDuration {
  Default = 700,
  GCD = 400,
  Long = 1400,
  Potion = 1300,
}
